import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Schedule } from 'src/app/models/schedule-models/schedule.model';
import { FormBasic } from 'src/app/models/turns-models/turns-form-basic.model';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { FormsTurnsService } from 'src/app/services/turns-services/forms-turns-service/forms-turns.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';

@Component({
  selector: 'app-turns-form-turn-schedules-card',
  templateUrl: './turns-form-turn-schedules-card.component.html',
  styleUrls: ['./turns-form-turn-schedules-card.component.scss']
})
export class TurnsFormTurnSchedulesCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() form: FormBasic;
  @Input() existingSchedules: Schedule[];

  existingSchedule = new FormControl(null);
  schedules: Schedule[] = [];
  updateSchedulesSubscription: Subscription;

  constructor(private formsTurnsService: FormsTurnsService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private snackbarService: SnackBarService) { }

  ngOnInit() { }

  ngOnChanges() {
    this.schedules = this.form && this.form.AvailabilityCalendarsBound ? this.form.AvailabilityCalendarsBound : [];
  }

  public addSchedule() {
    if (this.existingSchedule.value === null) {
      this.router.navigate(['turn-schedule'], { relativeTo: this.activatedRoute });
    } else {
      this.updateSchedulesSubscription = this.formsTurnsService.linkExistingFormAvailabilitySchedule(this.existingSchedule.value.InternalId, this.form.InternalId).pipe(
        tap(o => this.snackbarService.open('turns-page.snackbar messages.update form success', 'success')),
        tap(o => this.formsTurnsService.refreshForm()),
        tap(o => this.existingSchedule.patchValue(null))
      ).subscribe(
        () => { },
        error => this.snackbarService.open(error['error']['message'], 'error')
      );
    }
  }

  public editSchedule(schedule) {
    this.router.navigate(['turn-schedule', schedule.InternalId], { relativeTo: this.activatedRoute });
  }

  public deleteSchedule(schedule) {
    this.updateSchedulesSubscription = this.formsTurnsService.deleteFormAvailabilitySchedule(schedule.InternalId, this.form.InternalId).subscribe(
      () => {
        this.snackbarService.open('turns-page.snackbar messages.update form success', 'success');
        this.formsTurnsService.refreshForm();
      },
      error => this.snackbarService.open(error['error']['message'], 'error')
    );
  }

  ngOnDestroy() {
    if (this.updateSchedulesSubscription) { this.updateSchedulesSubscription.unsubscribe(); }
  }
}
